import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';

import { shouldShowChallenge } from './utils/homeState.mjs';

export default function addHeaderNavigation() {
  extend(HeaderPrimary.prototype, 'items', function (items) {
    const basePath = app.forum.attribute('basePath') || '';
    const translationPrefix = 'yingtao-forum-homepage.forum.nav';

    items.add(
      'yingtaoHome',
      LinkButton.component(
        {
          href: basePath + '/',
          icon: 'fas fa-home',
          className: 'Button Button--link YingtaoNavLink',
        },
        app.translator.trans(`${translationPrefix}.home`)
      ),
      45
    );

    items.add(
      'yingtaoAllDiscussions',
      LinkButton.component(
        {
          href: app.route('index'),
          icon: 'far fa-comments',
          className: 'Button Button--link YingtaoNavLink',
        },
        app.translator.trans(`${translationPrefix}.all_discussions`)
      ),
      44
    );

    items.add(
      'yingtaoShowcase',
      LinkButton.component(
        {
          href: app.route('tag', { tags: 'showcase' }),
          icon: 'fas fa-cubes',
          className: 'Button Button--link YingtaoNavLink',
        },
        app.translator.trans(`${translationPrefix}.showcase`)
      ),
      43
    );

    if (app.session.user) {
      items.add(
        'yingtaoFarm',
        LinkButton.component(
          {
            href: `${basePath}/farm`,
            icon: 'fas fa-seedling',
            className: 'Button Button--link YingtaoNavLink YingtaoNavLink--farm',
          },
          app.translator.trans(`${translationPrefix}.farm`)
        ),
        42.5
      );
    }

    if (shouldShowChallenge(app.store.all('tags'))) {
      items.add(
        'yingtaoChallenge',
        LinkButton.component(
          {
            href: app.route('tag', { tags: 'quarterly-challenge' }),
            icon: 'fas fa-trophy',
            className: 'Button Button--link YingtaoNavLink YingtaoNavLink--challenge',
          },
          app.translator.trans(`${translationPrefix}.challenge`)
        ),
        42
      );
    }
  });
}
